/** パウチ値・表の値セル用の入力フィルタ（PouchComponent と同一許可セット） */
const EXPRESSION_ALLOWED = /[^0-9+\-*/^xX×÷%.:~?='()]/g;

export type PouchValueKeyboardSymbolKey = {
  label: string;
  insert: string;
};

/** 自前数式キーボードの記号行（数字行の . / : ・操作キー除く） */
export const POUCH_EXPRESSION_KEYBOARD_SYMBOLS: PouchValueKeyboardSymbolKey[] = [
  { label: '+', insert: '+' },
  { label: '−', insert: '-' },
  { label: '×', insert: '×' },
  { label: '/', insert: '/' },
  { label: '^', insert: '^' },
  { label: "'", insert: "'" },
  { label: '%', insert: '%' },
  { label: '(', insert: '(' },
  { label: ')', insert: ')' },
  { label: '?', insert: '?' },
  { label: '=', insert: '=' },
  { label: ':', insert: ':' },
  { label: '~', insert: '~' },
];

/** 表の数量（マルチ値）セル用 */
const MULTIPLIER_ALLOWED = /[^0-9+\-.%]/g;

export type PouchValueKeyboardVariant = 'expression' | 'multiplier';

export function normalizeTimePouchValueInputText(s: string): string {
  return s
    .replace(/[０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xff10 + 0x30))
    .replace(/：/g, ':')
    .replace(/－/g, '-')
    .replace(/＇/g, "'")
    .replace(/（/g, '(')
    .replace(/）/g, ')');
}

export function filterPouchExpressionInput(raw: string, isTime = false): string {
  const normalized = isTime ? normalizeTimePouchValueInputText(raw) : raw
    .replace(/＇/g, "'")
    .replace(/（/g, '(')
    .replace(/）/g, ')');
  return normalized.replace(EXPRESSION_ALLOWED, '');
}

export function filterMultiplierValueInput(raw: string): string {
  return raw.replace(MULTIPLIER_ALLOWED, '');
}

export function filterPouchValueInput(
  raw: string,
  variant: PouchValueKeyboardVariant,
  isTime = false,
): string {
  return variant === 'multiplier'
    ? filterMultiplierValueInput(raw)
    : filterPouchExpressionInput(raw, isTime);
}

export function insertTextAtInputSelection(
  input: HTMLInputElement,
  currentValue: string,
  text: string,
): { value: string; caret: number } {
  const start = input.selectionStart ?? currentValue.length;
  const end = input.selectionEnd ?? start;
  const joined = currentValue.slice(0, start) + text + currentValue.slice(end);
  const caret = Math.min(start + text.length, joined.length);
  return { value: joined, caret };
}

export function isBlurToPouchValueKeyboard(relatedTarget: EventTarget | null): boolean {
  if (!(relatedTarget instanceof Element)) {
    return false;
  }
  return !!relatedTarget.closest('.pouch-value-keyboard-panel');
}

export function backspaceAtInputSelection(
  input: HTMLInputElement,
  currentValue: string,
): { value: string; caret: number } | null {
  const start = input.selectionStart ?? currentValue.length;
  const end = input.selectionEnd ?? start;
  if (start !== end) {
    const value = currentValue.slice(0, start) + currentValue.slice(end);
    return { value, caret: start };
  }
  if (start <= 0) {
    return null;
  }
  const value = currentValue.slice(0, start - 1) + currentValue.slice(start);
  return { value, caret: start - 1 };
}
